var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56296 6.78997C5.56918 7.00859 5.74819 7.18259 5.9669 7.18259C6.18561 7.18259 6.36463 7.00859 6.37085 6.78997L6.46404 3.51147C6.472 3.23138 6.24711 3 5.9669 3C5.68669 3 5.4618 3.23138 5.46977 3.51147L5.56296 6.78997ZM5.40002 8.43949C5.40002 8.74905 5.65097 9 5.96053 9H5.97327C6.28283 9 6.53378 8.74905 6.53378 8.43949C6.53378 8.12993 6.28283 7.87898 5.97327 7.87898H5.96053C5.65097 7.87898 5.40002 8.12993 5.40002 8.43949Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.ea977f8887ab90815ea143474fe8a36a.svg";
export { ForwardRef as ReactComponent };